import styled from "@emotion/styled";
import { LdLabel } from "@liquid/react";
import { StyledImage } from "@src/pages/HomePage/Tabs/SequenceInputForm/SequenceInputForm.style";

import { pxToRem } from "@src/utils";

const StyledRadioButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(10)};
  align-items: start;
`;

const StyledRequired = styled(LdLabel)`
  gap: ${pxToRem(3)};
  :after {
    content: " *";
  }
`;

const StyledImageWrapper = styled.div`
  display: block;
  position: relative;
`;

const StyledBEImage = styled(StyledImage)``;

const StyledPartImage = styled(StyledImage)`
  position: absolute;
  top: 0;
  width: 10px;
  height: 200px;
`;


export {
  StyledRadioButtonWrapper,
  StyledRequired,
  StyledImageWrapper,
  StyledBEImage,
  StyledPartImage,
};
